import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import FeaturesSection from './FeaturesSection';
import OffersSection from './OffersSection';
import Modal from './Modal'; // Make sure this exists
import TestimonialBox from './TestimonialBox';

const Layout = ({ children }) => {
  const [showQuoteModal, setShowQuoteModal] = useState(false);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      {/* <main style={{ flex: 1, padding: '1rem' }}>
        {children}
      </main> */}
      <FeaturesSection />
      <OffersSection />
      <TestimonialBox />
      {/* <PricingSection /> */}
      <Footer onQuoteClick={() => setShowQuoteModal(true)} />
      {showQuoteModal && <Modal onClose={() => setShowQuoteModal(false)} />}
    </div>
  );
};

export default Layout;
